import { makeAutoObservable, runInAction } from 'mobx'
import { restaurantCenter, restaurantConfig, RESTAURANT_EVENT, storeMobx } from 'restaurant'
import { advertMobx, decorationMobx } from '@mobxStore'
import Config from '@common/config/config'
import { forEach, camelCase, pick, cloneDeep } from '@dt/fe-utils/dist/lodash'
import DecorationApi from '@api/decoration.api'

const allTabs: ITabBarItem[] = [
  {
    type: 'home',
    icon: 'tab-home0',
    href: '/home',
    isShow: 0,
    mode: 0,
  },
  {
    type: 'meals',
    icon: 'tab-meals0',
    href: '/menu',
    isShow: 1,
    mode: 0,
  },
  {
    type: 'mall',
    icon: 'tab-mall0',
    href: '/mall',
    isShow: 0,
    mode: 0,
  },
  {
    type: 'orders',
    icon: 'tab-orders0',
    href: '/orders',
    isShow: 0,
    mode: 0,
  },
  {
    type: 'gifts',
    icon: 'tab-gifts0',
    href: '/giftCard',
    isShow: 0,
    mode: 0,
  },
  {
    type: 'my',
    icon: 'tab-my0',
    href: '/my',
    isShow: 1,
    mode: 0,
  },
]

// 字体大小配置
const defaultFontSetting = {
  name: { fontSize: 16, fontWeight: 1, },
  category: { fontSize: 14, fontWeight: 0, },
  price: { fontSize: 16, fontWeight: 0, },
}

// 默认商品详情配置
const defaultDetailDecorates: IDetailDecorates = {
  openFullNFree: 0,
  openFoldSoldoutScale: 1
}

const defaultMallGlobalDecorates: any = {
  displayMode: 'classic',
  collect: {
    home: '',
    img: {
      key: 'shopcart',
      type: 'icon',
      value: 'mall-shopcart2',
      icons: ['mall-shopcart2', 'mall-shopcart3', 'mall-shopcart1']
    },
  },
  // 主题颜色
  themeColor: '#161616',
  groupBuyShare: {
    title: '',
    image: ''
  },
  cartAndBuy: {
    cart: '',
    buy: ''
  }
}
const defaultAbnormalState = ['mealsemptystate', 'ordersemptystate', 'brandpauseorder', 'brandselectemptystate', 'couponemptystate'].filter(Boolean) as string[]
const defaultAbnormalStatesetting = defaultAbnormalState.map(item => {
  if (item === 'mealsemptystate') {
    return {
      type: item,
      name: '', // 点单页空状态
      subName: i18n.t('entry.abnormalStateNoProduct'),
      icon: `abnormalState-${item}new0`,
      pic: '',
      activePic: '',
      mode: 0 // 图标类型（0 系统图标 1 自定义）
    }
  } else if (item === 'ordersemptystate') {
    return {
      type: item,
      name: '', // 订单页空状态
      subName: i18n.t('entry.abnormalStateNoOrder'),
      icon: `abnormalState-${item}new0`,
      pic: '',
      activePic: '',
      mode: 0 // 图标类型（0 系统图标 1 自定义）
    }
  } else if (item === 'brandpauseorder') {
    return {
      type: item,
      name: '', // 门店暂停接单
      subName: '',
      icon: '',
      pic: `${'https://eshine-image.oss-cn-hangzhou.aliyuncs.com/product/43c15ee5a8aa4273a38943395d8c097f.png'}`,
      activePic: '',
      mode: 1 // 图标类型（0 系统图标 1 自定义）
    }
  } else if (item === 'couponemptystate') {
    return {
      type: item,
      name: '',
      subName: i18n.t('entry.abnormalStateNoCoupon'),
      icon: 'abnormalState-ordersemptystatenew0',
      pic: '',
      activePic: '',
      mode: 0 // 图标类型（0 系统图标 1 自定义）
    }
  } else {
    return {
      type: item,
      name: '', // 门店选择页空状态
      subName: i18n.t('entry.abnormalStateNoStoreOrder'),
      icon: `abnormalState-${item}new0`,
      pic: '',
      activePic: '',
      mode: 0 // 图标类型（0 系统图标 1 自定义）
    }
  }
})
class ThemeStore {
  constructor () {
    makeAutoObservable(this)
    // RESTAURANT_EVENT.STORE_CHANGED
    restaurantCenter.on(RESTAURANT_EVENT.STORE_CHANGED, (info: IStore) => {
      const hasStore = Config.STOREID
      decorationMobx.setDecoratesStoreId(info.storeId)
      // 获取广告装修方案
      DecorationApi.getDecorationCaseInfo(info.storeId).then(res => {
        // this.storeTemplateContent = res.storeTemplateContent || ''
        // if (window.location.pathname === '/menu') {
        //   this.setTemplateAdvert(res, info)
        // }
        let storeTemplateContent = res?.storeTemplateContent
        if (res?.storeTemplateContent) {
          try {
            const brandTemplateContent = JSON.parse(storeMobx.brand.brandTemplateContent)
            let storeTemplateContentObj = JSON.parse(res.storeTemplateContent)
            // 处理老数据
            if (storeTemplateContentObj?.isStoreSave !== 1) {
              storeTemplateContentObj = {
                ...brandTemplateContent
              }
            } else {
              storeTemplateContentObj.globalDecorates = {
                ...storeTemplateContentObj.globalDecorates,
                isEnterHome: brandTemplateContent.globalDecorates?.isEnterHome || 0,
                isEnterStore: brandTemplateContent.globalDecorates?.isEnterStore || 0,
                autoEnterStoreDistance: brandTemplateContent.globalDecorates?.autoEnterStoreDistance || 50
              }
            }
            storeTemplateContent = JSON.stringify(storeTemplateContentObj)
            runInAction(() => {
              this.storeTemplateAdvert = {
                // brandTemplateContent: res.brandTemplateContent,
                brandMobileAdvertList: res.brandMobileAdvertList,
                storeTemplateContent,
                storeMobileAdvertList: res.storeMobileAdvertList
              }
            })
          } catch (e) {
          }
        }
        // 只有当品牌码点单页或者非品牌码情况下才会使用门店个性化装修
        if ((restaurantConfig.codeType === 'brand' && (window.location.pathname === '/menu' || window.location.pathname === '/buyTogetherCart' || window.location.pathname.includes('/advertBrand') || window.location.pathname.includes('/recommend'))) || restaurantConfig.codeType !== 'brand') {
          if (restaurantConfig.codeType === 'brand' && (window.location.pathname === '/menu' || window.location.pathname.includes('/recommend'))) {
            this.setTemplateAdvert({ ...res, storeTemplateContent }, info.from === 'homeEntry', info)
          } else {
            this.setTemplateAdvert({ ...res, storeTemplateContent }, !hasStore, info)
          }
        }
      })
    })
  }

  /** 门店模板广告信息 */
  storeTemplateAdvert: any = ''

  /** 品牌模板信息 */
  brandTemplateDetails: any = null

  /** data */
  data: IThemeConfig = {
    /** 点餐主题色 */
    themeColor: '',
    /** 暗黑主题：light代表亮色，dark代表暗黑 */
    backgroundMode: 'light',
    /** 0代表瀑布流，1代表列表，2代表经典 */
    showTheStyle: 0,
    /** 底部自定义tab */
    tabBar: {
      tabs: [],
      enableName: 0,
      enablePosition: 1,
      backgroundColor: '',
      pagesShow: {
        home: 0,
        meals: 1,
        my: 1,
        orders: 0,
        mall: 0,
        gifts: 0,
      }
    },
    /** 品牌的头图URL，开启并有时才不为空 */
    brandHeaderUrl: '',
    /** 商家推荐 */
    recommendProducts: {
      /** 1代表开启，0代表关闭 */
      recommendProductsStatus: 0,
      /** 商家推荐自定义名称 */
      recommendProductsName: '',
      /** 0代表智能推荐，1代表自定义 */
      smartOrCustom: 0,
      /** 展示数量 */
      showCount: 0,
      /** 自定义餐品列表 */
      customProducts: []
    },
    /** 猜你喜欢：1代表开启，0代表关闭 */
    guessYouLike: 0,
    /** 购物车推荐：1代表开启，0代表关闭 */
    shoppingCartRecommendedStatus: 0,
    abnormalStateSetting: []
  }

  /** url search */
  get urlSearch (): string {
    const searchParams = ['ct', 'b', 's', 't']
    const searchValues = [Config.codeType, Config.BRANDID, Config.STOREID, Config.TABLECODE]
    let search: string = '?'
    searchParams.forEach((param, index) => {
      if (searchValues[index]) {
        search += `${param}=${searchValues[index]}&`
      }
    })
    if (search.length === 1) {
      search = ''
    } else {
      search = search.replace(/&$/, '')
    }
    return search
  }

  /** tabbar配置项 */
  get showTabs (): ITabBarItem[] {
    const tabs: ITabBarItem[] = allTabs
      .map((tab: ITabBarItem) => {
        const curTab = this.data.tabBar?.tabs?.find(v => v.type === tab.type) as ITabBarItem
        const mode = curTab?.mode !== undefined ? curTab?.mode : (curTab?.pic ? 1 : 0)
        const isShow = curTab && curTab?.isShow !== undefined ? curTab.isShow : (curTab ? 1 : 0)
        return {
          ...tab,
          ...curTab,
          isShow,
          mode
        }
      })
    return (tabs.length ? tabs : allTabs).filter(item => item.isShow === 1)
  }

  /** 页面显示tabbar */
  get showTabsPages (): any {
    const pagesShow = this.data.tabBar?.pagesShow
    const tabs: ITabBarItem[] = allTabs
      .map((tab: ITabBarItem) => {
        const curTab = this.data.tabBar?.tabs?.find(v => v.type === tab.type) as ITabBarItem
        const isShowTab = pagesShow ? pagesShow?.[tab.type] : tab.type === 'mall' ? 0 : curTab && curTab?.isShow !== undefined ? curTab.isShow : (curTab ? 1 : 0)
        return {
          ...tab,
          ...curTab,
          isShowTab,
        }
      })
    return tabs.filter((item) => item.isShowTab === 1)
  }

  /** setData */
  setData (data) {
    this.data = Object.assign(this.data, data)
  }

  /** setTemplateAdvert */
  setTemplateAdvert (templateAdvert: any, manualSwitch: boolean, storeInfo?: any) {
    // console.log('setTemplateAdvert:', templateAdvert, manualSwitch, storeInfo)
    const { brandMobileAdvertList, storeMobileAdvertList, brandTemplateContent, storeTemplateContent } = templateAdvert
    // console.log(brandMobileAdvertList, 'brandMobileAdvertList关于装修的逻辑', storeMobileAdvertList, 'storeMobileAdvertList')
    const recommendProducts = {
      customProducts: [],
      recommendProductsName: '',
      recommendProductsStatus: 1,
      showCount: 4,
      smartOrCustom: 0
    }
    if (brandTemplateContent || storeTemplateContent) {
      // 品牌(默认)装修信息
      this.brandTemplateDetails = brandTemplateContent ? JSON.parse(brandTemplateContent) : this.brandTemplateDetails || {}
      // 门店装修信息
      const storeTemplateDetails = storeTemplateContent ? JSON.parse(storeTemplateContent) : {}
      if (brandTemplateContent && storeTemplateContent) {
        // 处理老数据
        if (storeTemplateDetails?.isStoreSave !== 1) {
          storeTemplateDetails.globalDecorates = this.brandTemplateDetails.globalDecorates
          storeTemplateDetails.homeDecorates = this.brandTemplateDetails.homeDecorates
        } else {
          storeTemplateDetails.globalDecorates = {
            ...storeTemplateDetails.globalDecorates,
            isEnterHome: this.brandTemplateDetails.globalDecorates?.isEnterHome || 0,
            isEnterStore: this.brandTemplateDetails.globalDecorates?.isEnterStore || 0,
            autoEnterStoreDistance: this.brandTemplateDetails.globalDecorates?.autoEnterStoreDistance || 50
          }
        }
      }
      // 聚合装修信息
      // const decorateDetails = { ...brandTemplateDetails, ...pick(storeTemplateDetails, ['globalDecorates', Config.codeType !== 'brand' && 'homeDecorates', 'mealDecorates'].filter(Boolean)) } as IDecorateDetails
      let decorateDetails = { ...cloneDeep(this.brandTemplateDetails), ...pick(storeTemplateDetails, ['globalDecorates', 'homeDecorates', 'mealDecorates'].filter(Boolean)) } as IDecorateDetails
      const displayMode = decorateDetails?.mealDecorates?.displayMode

      const enableBrandHeader = storeInfo?.storeExtInfo.enableBrandHeader ? JSON.parse(storeInfo?.storeExtInfo.enableBrandHeader) : {}
      if (storeInfo?.storeExtInfo.recommendProducts) {
        forEach(JSON.parse(storeInfo?.storeExtInfo.recommendProducts), (value, key) => {
          recommendProducts[camelCase(key)] = value
        })
      }
      if (decorateDetails?.homeDecorates?.tabBarSetting) {
        const enableHome = decorateDetails?.homeDecorates?.enable
        decorateDetails.homeDecorates.tabBarSetting.tabs = decorateDetails?.homeDecorates?.tabBarSetting.tabs?.filter(item => item.type === 'home' ? enableHome : true)
      }
      decorateDetails.globalDecorates = {
        ...this.brandTemplateDetails.globalDecorates,
        ...decorateDetails.globalDecorates,
        btImg: this.brandTemplateDetails.globalDecorates?.btImg,
        btTxt: this.brandTemplateDetails.globalDecorates?.btTxt,
        abnormalStateSetting: this.brandTemplateDetails.globalDecorates?.abnormalStateSetting || defaultAbnormalStatesetting
      }
      decorateDetails = {
        ...decorateDetails,
        mealDecorates: {
          ...decorateDetails.mealDecorates,
          waterfall: {
            ...decorateDetails.mealDecorates.waterfall,
            openSoldoutHidden: this.brandTemplateDetails?.mealDecorates?.waterfall?.openSoldoutHidden || 0,
            openSoldout: this.brandTemplateDetails?.mealDecorates?.waterfall?.openSoldout || 0,
            openFoldSoldout: this.brandTemplateDetails?.mealDecorates?.waterfall?.openFoldSoldout || 0,
            fontSetting: this.brandTemplateDetails?.mealDecorates?.waterfall?.fontSetting || defaultFontSetting,
          },
          classic: {
            ...decorateDetails.mealDecorates.classic,
            openSoldoutHidden: this.brandTemplateDetails?.mealDecorates?.classic?.openSoldoutHidden || 0,
            openSoldout: this.brandTemplateDetails?.mealDecorates?.classic?.openSoldout || 0,
            openFoldSoldout: this.brandTemplateDetails?.mealDecorates?.classic?.openFoldSoldout || 0,
            fontSetting: this.brandTemplateDetails?.mealDecorates?.classic?.fontSetting || defaultFontSetting,
          },
          waterfallCategory: {
            ...decorateDetails.mealDecorates.waterfallCategory,
            openSoldoutHidden: this.brandTemplateDetails?.mealDecorates?.waterfallCategory?.openSoldoutHidden || 0,
            openSoldout: this.brandTemplateDetails?.mealDecorates?.waterfallCategory?.openSoldout || 0,
            openFoldSoldout: this.brandTemplateDetails?.mealDecorates?.waterfallCategory?.openFoldSoldout || 0,
            fontSetting: this.brandTemplateDetails?.mealDecorates?.waterfallCategory?.fontSetting || defaultFontSetting,
          },
          detailDecorates: this.brandTemplateDetails?.mealDecorates?.detailDecorates || defaultDetailDecorates
        },
        mallGlobalDecorates: {
          ...(decorateDetails.mallGlobalDecorates || defaultMallGlobalDecorates),
          collect: {
            ...defaultMallGlobalDecorates.collect,
            ...(decorateDetails?.mallGlobalDecorates?.collect || {}),
            home: decorateDetails.mallGlobalDecorates?.collect?.home || ''
          },
          cartAndBuy: {
            ...defaultMallGlobalDecorates.cartAndBuy,
            ...(decorateDetails.mallGlobalDecorates?.cartAndBuy || {}),
            cart: decorateDetails.mallGlobalDecorates?.cartAndBuy?.cart || decorateDetails.mallGlobalDecorates?.collect?.detail || ''
          },
        }
      }
      // 异常状态数据异常处理
      if (decorateDetails?.globalDecorates?.abnormalStateSetting) {
        if (!decorateDetails.globalDecorates.abnormalStateSetting.find(item => item.type === 'couponemptystate')) {
          decorateDetails.globalDecorates.abnormalStateSetting.push(defaultAbnormalStatesetting.filter((item: IAbnormalStateItem) => item.type === 'couponemptystate')[0])
        }
        decorateDetails.globalDecorates.abnormalStateSetting = decorateDetails?.globalDecorates?.abnormalStateSetting.map(item => {
          item.icon = item?.icon?.replace('tab-', 'abnormalState-')
          item.subName = item?.subName || defaultAbnormalStatesetting?.find(i => i.type === item?.type)?.subName
          return item
        })
      }
      // 处理主题
      this.setData({
        /** 0代表瀑布流，1代表列表，2代表经典 */
        showTheStyle: displayMode === 'waterfall' ? 0 : 2,
        themeColor: decorateDetails?.globalDecorates?.themeColor,
        // tabBar
        tabBar: decorateDetails?.globalDecorates?.tabBarSetting || decorateDetails?.homeDecorates?.tabBarSetting,
        // 异常状态数据
        abnormalStateSetting: decorateDetails?.globalDecorates?.abnormalStateSetting || defaultAbnormalStatesetting,
        /** 品牌头图 */
        brandHeaderUrl: enableBrandHeader?.enableBrandHeaderStatus && enableBrandHeader?.enableBrandHeaderUrl,
        /** 商家推荐 */
        recommendProducts,
        /** 猜你喜欢：1代表开启，0代表关闭 */
        guessYouLike: parseInt(storeInfo?.storeExtInfo.guessYouLike || '1'),
        /** 是否购物车推荐：1代表开启，0代表关闭 */
        shoppingCartRecommendedStatus: parseInt(storeInfo?.storeExtInfo.shoppingCartRecommendedStatus || '0'),
      })

      if (restaurantCenter.config.displayMode !== displayMode) {
        restaurantCenter.setConfig({
          displayMode: displayMode || 'classic'
        })
      }
      decorationMobx.setDecorateInfos(decorateDetails, manualSwitch, storeInfo ? 'store' : 'brand')
      advertMobx.setAdverList(brandMobileAdvertList, storeMobileAdvertList, manualSwitch)
    }
  }
}

export default new ThemeStore()
